const env = process.env.NODE_ENV
const isProd = env === 'production'

export const baseApiUrl = isProd ? 'https://dentalplace.smileaja.com/api/' : 'http://localhost:6025/api/'
export const uploaderUrl = isProd ? 'https://dentalplace.smileaja.com/upload/' : 'http://localhost:6027/'